import React, { useEffect, useState } from 'react';
import { getAllTerms} from '../../services/termService';
import axiosInstance from '../../api/axios';

import { Link } from "react-router-dom";
import "./datatable.scss"
import { DataGrid } from '@mui/x-data-grid';

export const TermList=()=> {
    const [terms, setTerms] = useState([]);
    const [degreeMap, setDegreeMap] = useState({});
    const [programMap, setProgramMap] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const fetchTerms = async () => {
        try {
            const data = await getAllTerms();
           // console.log(data);
            setTerms(data.data);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };
    const fetchDegreesAndPrograms = async () => {
        try {
            const [degreesRes, programsRes] = await Promise.all([
                axiosInstance.get('/getAllDegrees'),
                axiosInstance.get('/getAllPrograms'),
            ]);
            setDegreeMap(Object.fromEntries((degreesRes.data?.data || []).map(d => [d.id, d.degreeName])));
            setProgramMap(Object.fromEntries((programsRes.data?.data || []).map(p => [p.id, p.programName])));
        } catch (err) {
            console.error('Error fetching degrees/programs:', err);
        }
    };
    useEffect(() => {

        fetchTerms();
        fetchDegreesAndPrograms();
    }, []);

    const transformedRows = terms.map(row => ({
        ...row,
        batch: row.batch || 'All Batches',
        degreeName: row.degreeId ? degreeMap[row.degreeId] : 'All Degrees',
        programName: row.programId ? programMap[row.programId] : 'All Programs',
    }));

    const columns = React.useMemo(
        () => [
            { field: 'name', headerName: 'Name', width: 150 },
            { field: 'batch', headerName: 'Batch', width: 130 },
            { field: 'degreeName', headerName: 'Degree', width: 150 },
            { field: 'programName', headerName: 'Program', width: 180 },
            { field: 'startDate', headerName: 'Start Date', width: 150 },
            { field: 'endDate', headerName: 'End Date', width: 120 },
            { field: 'midSemDate', headerName: 'Project Particular Submission Date', width: 180 },
            { field: 'endSemDate', headerName: 'End Sem Date', width: 180 }
        ],
        []
    );

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    const actionColumn = [{ field: "action", headerName:"Action", width:200,
        renderCell:(params)=>{
            const { id } = params.row;
            return(
                <div className="cellAction">
                    <div className="viewButton"><Link to={{pathname: `/terms/view-term/${id}`}} style={{textDecoration:"none"}}>View</Link></div>
                    <div className="editButton"><Link to={{pathname: `/terms/edit-term/${id}`}} style={{textDecoration:"none" }}>Edit</Link></div>
                </div>
            );
        }
    }]

    return (
        <div className="datatable" >
        <div className="datatableTitle">


          <Link to="/terms/new" className="link" >
          Add Term
          </Link>

        </div>
      
      <DataGrid
      rows={transformedRows}
      columns={columns.concat(actionColumn)}
      initialState={{
        pagination: {
          paginationModel: { page: 0, pageSize: 10 },
        },
      }}
      pageSizeOptions={[5, 10]}
      //checkboxSelection
    />
  </div>
    );
}

